// extracted by mini-css-extract-plugin
export default {"root":"InvestorRelationshipCard_root__8Vjs5","displayHeader":"InvestorRelationshipCard_displayHeader__cwgB+"};